import { render, staticRenderFns } from "./ActivationCode.vue?vue&type=template&id=45dafe84&scoped=true"
import script from "./ActivationCode.vue?vue&type=script&lang=js"
export * from "./ActivationCode.vue?vue&type=script&lang=js"
import style0 from "./ActivationCode.vue?vue&type=style&index=0&id=45dafe84&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dafe84",
  null
  
)

export default component.exports